import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { misc } from "app/themes/colors";

const sx = {
  background: misc.highlightPurple,
  width: "fit-content",
  p: 3,
  borderRadius: "8px"
};

export default function FeatureIsNotAvailable({
  featureName
}: {
  featureName: string;
}) {
  const navigate = useNavigate();

  return (
    <Stack gap={2} alignItems="flex-start" p={2}>
      <Typography fontSize="18px" mt={2} sx={sx}>
        Please contact support to enable <b>{featureName}</b>.
      </Typography>
      <Button
        onClick={() => {
          navigate("/");
        }}
      >
        Return
      </Button>
    </Stack>
  );
}
